import '../../../../Assets/app.base';
import lightGallery from 'lightgallery'
import 'lightgallery/scss/lightgallery-bundle.scss'
import lgAutoplay from 'lightgallery/plugins/autoplay'
import lgFullscreen from 'lightgallery/plugins/fullscreen'
import lgThumbnail from 'lightgallery/plugins/thumbnail'
import lgZoom from 'lightgallery/plugins/zoom'
import './Album.scss';

function init(element, config) {
    lightGallery(element[0], {
        licenseKey: '0759F4F3-F216423C-9C28B207-1BF53A5E',
        plugins: [lgAutoplay, lgFullscreen, lgThumbnail, lgZoom],
        selector: 'img',
        exThumbImage: 'data-thumbnail'
    })
    element.on('onAfterSlide.lg', (event, prevIndex, index) => {
        const targetElement = element.find('a').get(index)
        const targetUrl = $(targetElement).attr('href')

        history.replaceState({}, '', targetUrl)
    })
    element.on('onCloseAfter.lg', (event) => {
        history.replaceState({}, '', config.AlbumDetailUrl)
    })

    if (config.IsShowPartyphotoImage) {
        const id = config.PartyphotoImageId
        const target = element.find(`a[data-id="${id}"] img`)

        target.trigger('click')
    }
}

$(function () {
    const config = window.partyphotoAlbumControllerInit
    const element = $('#album-images')

    init(element, config)
})